import React from 'react';
var useEffect = React.useEffect;
export function usePageTitle(title) {
    useEffect(function () {
        document.title = title + ' | VMware Aria Suite Lifecycle';
    }, [title]);
}
